<template>
  <a :href="link" :target="target">
    <div class="container">{{title}}</div>
  </a>
</template>

<script>
export default {
  name: "Button",
  props: {
    title: String,
    link: String,
    target: String,
  },
};
</script>

<style scoped>
.container {
  border: 1px #005aff solid;
  text-align: center;
  width: auto;
  padding: 10px;
  color: #1057da;
  margin: 5px;
}
a {
  text-decoration: none;
}
</style>